import React, { useRef, useState } from "react";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import * as Yup from "yup";
import { useFormik } from "formik";
import { useDispatch } from "react-redux";
import classNames from "classnames";
import { handlePostRequest } from "../../../../services/PostTemplate";
import SecuredFileChange from "../../../../components/SecuredFileChange/SecuredFileChange";
import { Dialog } from "primereact";

const AddFeature = ({ onHide, getFeatureList }) => {
    const [selectedFile, setSelectedFile] = useState(null);
    const [selectedFileError, setSelectedFileError] = useState(null);
    const [featurelogoLink, setFeaturelogoLink] = useState("");
    const [loadingBtn, setLoadingBtn] = useState(false);
    const featureImageRef = useRef(null);
    const [displayImageDialog, setDisplayImageDialog] = useState(false);

    const dispatch = useDispatch();

    const validationSchema = Yup.object().shape({
        text: Yup.string()
            ?.matches(/^[^\s]+(\s[^\s]+)*$/, "Leading and trailing space is not allowed")
            .required("This field is required"),

        image: Yup.string().required("This field is required"),
    });

    const formik = useFormik({
        validationSchema: validationSchema,
        initialValues: {
            text: "",
            image: "",
        },

        onSubmit: async (data) => {
            setLoadingBtn(true);

            let newData = {
                text: data?.text,
                image: selectedFile ? selectedFile : "",
            };

            const response = await dispatch(handlePostRequest(newData, "/api/v1/feature", false, true));
            if (response?.status === 200) {
                getFeatureList();
                onHide();
            }
            setLoadingBtn(false);
        },
    });

    const previewImage = () => {
        setDisplayImageDialog(true);
    };
    const closeDisplayDialog = () => {
        setDisplayImageDialog(false);
    };

    const handleImageReset = () => {
        formik.setFieldValue("image", "");
        setSelectedFile(null);
        setFeaturelogoLink("");
        featureImageRef.current.value = null; // Reset the file input value
    };
    const handleFeatureIcon = () => {
        featureImageRef.current.click();
    };

    function handleFeatureImageChange(event) {
        setSelectedFile(null);
        formik.setFieldValue("image", "");
        setSelectedFileError("");
        const selectedFile = event.target.files[0];
        const fileTypes = ["image"];
        const { file: newFile, error } = SecuredFileChange(selectedFile, fileTypes);
        if (error) {
            setSelectedFileError(error);
        } else if (newFile) {
            setFeaturelogoLink(URL.createObjectURL(selectedFile));
            formik.setFieldValue("image", newFile?.name);
            const reader = new FileReader();
            reader.onloadend = () => {
                const base64String = reader.result;
                setSelectedFile(base64String);
            };
            reader.readAsDataURL(newFile);
        }
    }

    const isFormFieldValid = (name) => !!(formik.touched[name] && formik.errors[name]);
    const getFormErrorMessage = (name) => {
        return isFormFieldValid(name) && <small className="p-error">{formik.errors[name]}</small>;
    };

    return (
        <>
            <Dialog visible={displayImageDialog} blockScroll style={{ width: "40vw" }} maskClassName="zindex9999" onHide={() => closeDisplayDialog()} draggable={false}>
                <img src={selectedFile} style={{ maxWidth: "100%", maxHeight: "100%", width: "900px", height: "500px", objectFit: "contain" }} />
            </Dialog>
            <form onSubmit={formik.handleSubmit}>
                <div className="p-fluid formgrid grid pl-2 pr-2">
                    <div className="field col-12 md:col-6">
                        <label> Feature Name </label>
                        <span className="Label__Required">*</span>
                        <InputText placeholder="Enter Feature Name" className={classNames({ "p-invalid": isFormFieldValid("text") }, "Input__Round")} id="text" name="text" maxLength={30} value={formik.values.text} onChange={formik.handleChange} type="text" />
                        {getFormErrorMessage("text")}
                    </div>
                    <div className="field col-12 md:col-6">
                        <label> Upload Image </label> <span className="Label__Required">*</span>
                        <div className="file-input-container " onClick={handleFeatureIcon}>
                            <input type="file" accept="image/*" style={{ display: "none" }} ref={featureImageRef} onChange={handleFeatureImageChange} />
                            <input className={classNames({ "p-invalid": isFormFieldValid("image") }, "custom-file p-inputtext p-component Input__Round")} type="text" placeholder="Choose a file..." value={formik.values.image} readOnly />
                            <span className="file-upload-icon">
                                <i className="pi pi-paperclip" />
                            </span>
                        </div>
                        {selectedFileError ? <small className="p-error">{selectedFileError}</small> : getFormErrorMessage("image")}
                        {formik?.values?.image && (
                            <div style={{ position: "relative", width: "180px", height: "180px", margin: "auto", marginTop: "15px" }}>
                                <i className="pi pi-times closingIcon" onClick={() => handleImageReset()} style={{ cursor: "pointer", position: "absolute", top: "0", right: "0" }} />
                                <img
                                    src={featurelogoLink}
                                    alt="Feature Image"
                                    style={{ maxWidth: "100%", maxHeight: "100%", width: "150px", height: "150px", objectFit: "contain" }}
                                    onClick={() => {
                                        previewImage();
                                    }}
                                />
                            </div>
                        )}
                    </div>
                    <div className="col-12 d-flex flex-row text-center mt-4 pb-2">
                        <Button className="Cancel-Button" label="Cancel" type="button" onClick={onHide} />
                        <Button className="Save-Button ml-2" label="Add" type="submit" loading={loadingBtn} />
                    </div>
                </div>
            </form>
        </>
    );
};

export default AddFeature;
